
import React, { useState, useEffect } from "react";
import Header from "../../Core/Header";
import { toast } from "react-toastify";
import { createAudiometers, getAllAudiometerById, getAllAudiometers, serviceAdd, subServiceList, updateServicedata, updateServiceOnlineStatus, updateServiceToggle, updateSubCategoryStatus, updateSubCategoryToggle } from "../../Services/Operations/ProductAPI";
import { Section } from "../../Core/Section";
import { Modal, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { baseURL } from "../../Services/api_endpoints";
const Audiometer = () => {

      const token = useSelector((state) => state.user.token);
  console.log("token : ", token);
  const [cartUpdated, setServiceUpdated] = useState(false);
    const [SubcategoryUpdated, setSubcategoryUpdated] = useState(false);
  const [service, setService] = useState([]);
  const[audiometers,setAudiometers]=useState([])
  const [name,setName]=useState("")
  const[desc,setDesc]=useState("")
  const [shortname,setShortName]=useState("")
  const [img,setImg]=useState(null)
  const [formData, setFormData] = useState({   // this for add new service
    serviceName: "",
    serviceDescription: "",
   serviceShortName:"",
    serviceImageFile:null
  });

   const [formEditData, setFormEditData] = useState({
    serviceName: "",
    serviceDescription: "",
   serviceShortName:"",
    serviceImageFile:null
  });
  const[companyName,setcompanyName]=useState("")
  const[model,setmodel]=useState("")
  const[type,settype]=useState("")
  const[serialNumber,setserialNumber]=useState("")
  const[acHeadPhone,setacHeadPhone]=useState("")
  const[bcVibrator,setbcVibrator]=useState("")
  const[serviceIds,setserviceIds]=useState([])
  const [showModal, setShowModal] = useState(false);
   const [editModal, setEditModal] = useState(false);
  const [selectedService, setSelectedService] = useState(null);



    const fetchServiceList = async () => {
      try {
        const response = await subServiceList(token);
        console.log("service list:", response);
        setService(Array.isArray(response)?response:[]);
      } catch (error) {
        console.error("Error updating profile:", error);
      }
    };

       const fetchAllAudiometers = async () => {
      try {
        const response = await getAllAudiometers(token);
        console.log("getAllAudiometers:", response);
        setAudiometers(Array.isArray(response.data)?response.data:[]);
      } catch (error) {
        console.error("Error updating profile:", error);
      }
    };


  const handleViewDetails = async(id) => {
    try {
        const res=await getAllAudiometerById(token,id)
        console.log(res);
        if(res.status===200){
          setSelectedService(res.data); 
             setShowModal(true);
        }
        
    } catch (error) {
        console.log(error);
        
    }
    
  
  };

  const handleViewEdit = (service) => {
    console.log(service);
    
    setSelectedService(service);
    setName(service?.serviceName)
    setDesc(service?.serviceDescription)
    setShortName(service?.serviceShortName||"")
    setImg(service?.serviceImage)
  //   setFormEditData({
  //      serviceName:,
  //   serviceDescription: ,
  //  serviceShortName:,
  //   serviceImageFile:
  //   })
    setEditModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedService(null);
  };
  const handleEditCloseModal = () => {
    setEditModal(false);
    setSelectedService(null);
  };

   const toggleOnlineStatus = async (id) => {
      try {
        const response = await updateServiceOnlineStatus(id,token);
        console.log("online status :", response);
        if (response.data.status === "success") {
          setSubcategoryUpdated((prev) => !prev);
           fetchServiceList()
        }
      } catch (error) {
        console.error("Error updating profile:", error);
      }
    };

    const toggleStatus = async (id) => {
        try {
          const response = await updateServiceToggle(id,token);
          console.log("toggle status :", response);
          if (response.data.status === "success") {
            setSubcategoryUpdated((prev) => !prev);
            fetchServiceList()
          }
        } catch (error) {
          console.error("Error updating profile:", error);
        }
      };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

    const handleEditChange = (e) => {
    const { name, value } = e.target;
    setFormEditData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
    //   const formDataToSend=new FormData();
    //    Object.entries(formData).forEach(([key, value]) => {
    //     formDataToSend.append(key, value);
    //   });
    let data={
        companyName,
        model,
        type,
        acHeadPhone,
        bcVibrator,
        serialNumber,
        serviceIds
    }
      
      const response = await createAudiometers(data,token);
      console.log("audiometer add response:", response);

    

      if (response.status === 201) {
        toast.success("audiometer added successfully");
        fetchAllAudiometers()
        
      } else {
        toast.error(response.data?.message || "Failed to add audiometer");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error adding audiometer");
    }
  };

  const EditSubmit=async()=>{
    setFormEditData({
      serviceName:name,
     serviceDescription: desc,
    serviceShortName:shortname,
     serviceImageFile:img
    })
    const formData=new FormData()
    formData.append("serviceName",name)
    formData.append("serviceDescription",desc)
    formData.append("serviceShortName",shortname)
    formData.append("serviceImageFile",img)
    try {
      const res= await updateServicedata(selectedService.id,formData,token)
      console.log(res);
      if(res.status===200){
        toast.success("Service updated successfully");
        handleEditCloseModal();
        fetchServiceList()
      }
      
    } catch (error) {
      console.log(error);
      
    }
  }

 
  
  useEffect(() => {
 
  fetchAllAudiometers()
    fetchServiceList();
  }, []);

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;

    if (checked) {
      // PUSH: Add value to the array
      setserviceIds((prev) => [...prev, value]);
    } else {
      // REMOVE: Filter out the value if unchecked
      setserviceIds((prev) => prev.filter((item) => item !== value));
    }
  };


     const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  
  const currentServices = audiometers?.slice(indexOfFirst, indexOfLast);
  return (
       <div id="main_content">
          <Header />
          <div className="page">
          
            <Section />
            <div className="section-body">
              <div className="container-fluid">
                <div className="d-flex justify-content-between align-items-center ">
                  <div className="header-action">
                    <h1 className="page-title">Audiometers</h1>
                    <ol className="breadcrumb page-breadcrumb">
                      <li className="breadcrumb-item">
                        <a href="#">RNDSAN</a>
                      </li>
                      <li className="breadcrumb-item active" aria-current="page">
                        Audiometers
                      </li>
                    </ol>
                  </div>
                  <ul className="nav nav-tabs page-header-tab">
                    <li className="nav-item">
                      <a
                        className="nav-link active"
                        data-toggle="tab"
                        href="#Student-all"
                      >
                        List View
                      </a>
                    </li>
                   
                    <li className="nav-item">
                      <a className="nav-link" data-toggle="tab" href="#Student-add">
                        Add
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="section-body mt-4">
              <div className="container-fluid">
                <div className="tab-content">
                  <div className="tab-pane active" id="Student-all">
                  
                    <div className="table-responsive card">
                      <table className="table table-hover table-vcenter table-striped mb-0 text-nowrap">
                        <thead>
                          <tr>
                            <th style={{textAlign:"center"}}>Id</th>
                            <th style={{textAlign:"center"}}>companyName</th>
                           
                            <th style={{textAlign:"center"}}>bcVibrator</th>
                             <th style={{textAlign:"center"}}>acHeadPhone</th>
                              <th style={{textAlign:"center"}}>model</th>
                            <th style={{textAlign:"center"}}>serialNumber</th>
                             <th style={{textAlign:"center"}}>view</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentServices?.map((service,ind) => (
                            <tr key={service?.id}>
                              <td>{indexOfFirst+ind+1}</td>
                              <td>{service?.companyName}</td>
                            
                              <td>
                                {service?.bcVibrator}
                              </td>
                              <td>
                               {service?.acHeadPhone}
                              </td>
                               <td>
                                {service?.model}
                              </td>
                              <td>
                               {service?.serialNumber}
                               
                              </td>
                              <td>
                                 <button
                              type="button"
                              className="btn btn-icon btn-sm"
                              title="View"
                              onClick={() => handleViewDetails(service.id)}
                            >
                              <i className="fa fa-eye" />
                            </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
    
                                   <div className="pagination mt-3" style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                                 <button
        disabled={currentPage === 1}
        onClick={() => setCurrentPage((prev) => prev - 1)}
        className="btn btn-primary btn-sm me-2"
      >
        Prev
                         </button>
    
                          <span> Page {currentPage} of {Math.ceil(audiometers.length / itemsPerPage)} </span>
    
                      <button
        disabled={currentPage === Math.ceil(audiometers.length / itemsPerPage)}
        onClick={() => setCurrentPage((prev) => prev + 1)}
        className="btn btn-primary btn-sm ms-2"
      >
        Next
                   </button>
    </div>
                    </div>
                  </div>
                 
                  <div className="tab-pane" id="Student-add">
                    <div className="row clearfix">
                      <div className="col-md-12 col-sm-12">
                        <div className="card">
                          <div className="card-header">
                            <h3 className="card-title">Basic Information</h3>
                            <div className="card-options ">
                          
                            </div>
                          </div>
                          <form className="card-body" onSubmit={handleSubmit}>
                            <div className="form-group row">
                              <label className="col-md-3 col-form-label">
                                companyName
                              </label>
                              <div className="col-md-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="companyName"
                                  placeholder="Enter Service Name"
                                  value={companyName}
                                  onChange={(e)=>setcompanyName(e.target.value)}
                                  required
                                />
                              </div>
                            </div>
                             <div className="form-group row">
                              <label className="col-md-3 col-form-label">
                                model
                              </label>
                              <div className="col-md-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="model"
                                  placeholder="Enter Service Name"
                                  value={model}
                                  onChange={(e)=>setmodel(e.target.value)}
                                  required
                                />
                              </div>
                            </div>
                             <div className="form-group row">
                              <label className="col-md-3 col-form-label">
                                type
                              </label>
                              <div className="col-md-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="type"
                                  placeholder="Enter Service Name"
                                  value={type}
                                  onChange={(e)=>settype(e.target.value)}
                                  required
                                />
                              </div>
                            </div>
                             <div className="form-group row">
                              <label className="col-md-3 col-form-label">
                                serialNumber
                              </label>
                              <div className="col-md-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="serialNumber"
                                  placeholder="Enter Service Name"
                                  value={serialNumber}
                                  onChange={(e)=>setserialNumber(e.target.value)}
                                  required
                                />
                              </div>
                            </div>
                             <div className="form-group row">
                              <label className="col-md-3 col-form-label">
                                acHeadPhone
                              </label>
                              <div className="col-md-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="acHeadPhone"
                                  placeholder="Enter Service Name"
                                  value={acHeadPhone}
                                  onChange={(e)=>setacHeadPhone(e.target.value)}
                                  required
                                />
                              </div>
                            </div>

                             <div className="form-group row">
                              <label className="col-md-3 col-form-label">
                                bcVibrator
                              </label>
                              <div className="col-md-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="bcVibrator"
                                  placeholder="Enter Service Name"
                                  value={bcVibrator}
                                  onChange={(e)=>setbcVibrator(e.target.value)}
                                  required
                                />
                              </div>
                            </div>

                             <div className="form-group row">
                              <label className="col-md-3 col-form-label">
                                Services
                              </label>
                              <div className="col-md-9">
                               {
                                service.map(i=><div style={{display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "10px 15px",
    marginBottom: "8px",
    borderRadius: "6px",
    border: "1px solid #e0e0e0",
    backgroundColor: "#fff",
    cursor: "pointer",
    transition: "background-color 0.2s",
    // Adding a subtle shadow to make it look like a form element
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)"}}>
                                    <input
                                    type="checkbox"
                                    value={i.id}
                                    onChange={handleCheckboxChange}
                                    style={{ cursor: 'pointer', margin: 0 ,width: "18px", 
      height: "18px",}}/>
                                    <p style={{ 
        margin: 0,        // CRITICAL: Removes the default P tag spacing
        fontSize: "14px", 
        cursor: 'pointer' 
    }}
                                    >{i.serviceName}</p>
                                </div>)
                               }
                              </div>
                            </div>
    
                           
    
                            <div className="col-sm-12">
                              <button type="submit" className="btn btn-primary">
                                Submit
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                      {/* <div className="col-lg-4 col-md-12 col-sm-12">
                        <div className="card">
                          <div className="card-header">
                            <h3 className="card-title">Account Information</h3>
                            <div className="card-options ">
                              <a
                                href="#"
                                className="card-options-collapse"
                                data-toggle="card-collapse"
                              >
                                <i className="fe fe-chevron-up" />
                              </a>
                              <a
                                href="#"
                                className="card-options-remove"
                                data-toggle="card-remove"
                              >
                                <i className="fe fe-x" />
                              </a>
                            </div>
                          </div>
                          <div className="card-body">
                            <div className="row clearfix">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <label>Service Name</label>
                                  <input type="text" className="form-control" />
                                </div>
                              </div>
                              <div className="col-md-6 col-sm-12">
                                <div className="form-group">
                                  <label>Password</label>
                                  <input type="text" className="form-control" />
                                </div>
                              </div>
                              <div className="col-md-6 col-sm-12">
                                <div className="form-group">
                                  <label>Confirm Password</label>
                                  <input type="text" className="form-control" />
                                </div>
                              </div>
                              <div className="col-sm-12">
                                <button type="submit" className="btn btn-primary">
                                  Submit
                                </button>
                                <button
                                  type="submit"
                                  className="btn btn-outline-secondary"
                                >
                                  Cancel
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card">
                          <div className="card-header">
                            <h3 className="card-title">Account Information</h3>
                            <div className="card-options ">
                              <a
                                href="#"
                                className="card-options-collapse"
                                data-toggle="card-collapse"
                              >
                                <i className="fe fe-chevron-up" />
                              </a>
                              <a
                                href="#"
                                className="card-options-remove"
                                data-toggle="card-remove"
                              >
                                <i className="fe fe-x" />
                              </a>
                            </div>
                          </div>
                          <div className="card-body">
                            <div className="form-group">
                              <label>Facebook</label>
                              <input type="text" className="form-control" />
                            </div>
                            <div className="form-group">
                              <label>Twitter</label>
                              <input type="text" className="form-control" />
                            </div>
                            <div className="form-group">
                              <label>LinkedIN</label>
                              <input type="text" className="form-control" />
                            </div>
                            <div className="form-group">
                              <label>Behance</label>
                              <input type="text" className="form-control" />
                            </div>
                            <div className="form-group">
                              <label>dribbble</label>
                              <input type="text" className="form-control" />
                            </div>
                            <button type="submit" className="btn btn-primary">
                              Submit
                            </button>
                            <button
                              type="submit"
                              className="btn btn-outline-secondary"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Modal show={showModal} onHide={handleCloseModal} size="md">
              <Modal.Header closeButton>
                <Modal.Title>Service Details</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {selectedService ? (
                  <div>
                    
                    <p>
                      <strong>ID:</strong> {selectedService.id}
                    </p>
                    <p>
                      <strong>Company Name:</strong> {selectedService.companyName}
                    </p>
                    <p>
                      <strong>Type:</strong>{" "}
                      {selectedService.type}
                    </p>
                    <p>
                      <strong>acHeadPhone:</strong>{" "}
                      {selectedService.acHeadPhone}
                    </p>
                    <p>
                      <strong>bcVibrator:</strong>{" "}
                      {selectedService.bcVibrator}
                    </p>
                    <p>
                      <strong>model:</strong>{" "}
                      {selectedService.model}
                    </p>
                    <p>
                      <strong>serialNumber:</strong>{" "}
                      {selectedService.serialNumber}
                    </p>
                    <p>
                      <strong>Services:</strong>{" "}
                      {(selectedService.services).map(i=>
                      <div style={{padding:"10px 20px",borderLeft:"2px solid grey"}}>
                        <p>Name:{i.serviceName}</p>
                        <p>Short name:{i.serviceShortName}</p>
                        <p>Price{i.servicePrice}</p>
                        <p>Desc:{i.serviceDescription}</p>
                         <p>Online available:{i.onlineAvailable}</p>
                      </div>)}
                    </p>
                  </div>
                ) : (
                  <p>No details available</p>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModal}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
    
            {/* update modal */}
             <Modal show={editModal} onHide={handleEditCloseModal} size="md">
              <Modal.Header closeButton>
                <Modal.Title>Service Edit</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {selectedService ? (
                  <div>
                    <p>
                      <strong>ID:</strong> {selectedService.id}
                    </p>
                    <p>
                      <strong>Service Name:</strong> 
                      <input name="name" value={name} onChange={(e)=>setName(e.target.value)}/>
                    </p>
                    <p>
                      <strong>Description:</strong>{" "}
                      <input name="desc" value={desc} onChange={(e)=>setDesc(e.target.value)}/>
                    </p>
                    <p>
                      <strong>Short Name:</strong>{" "}
                     <input name="shortname" value={shortname} onChange={(e)=>setShortName(e.target.value)}/>
                    </p>
                    <p>
                      <strong>Image:</strong>{" "}
                     <input name="img" type="file"  onChange={(e)=>setImg(e.target.files[0])}/>
                    </p>
                    <Button variant="secondary" onClick={EditSubmit}>
                  Edit
                </Button>
                  </div>
                ) : (
                  <p>No details available</p>
                )}
              </Modal.Body>
              <Modal.Footer>
                
              </Modal.Footer>
            </Modal>
            <div className="section-body">
              <footer className="footer">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-md-6 col-sm-12">
                      Copyright © 2025{" "}
                      <a href="">Technology support By - Siance Software Pvt Ltd</a>
                      .
                    </div>
                    {/* <div className="col-md-6 col-sm-12 text-md-right">
                      <ul className="list-inline mb-0">
                        <li className="list-inline-item">
                          <a href="../doc/index.html">Documentation</a>
                        </li>
                        <li className="list-inline-item">
                          <a href="javascript:void(0)">FAQ</a>
                        </li>
                        <li className="list-inline-item">
                          <a
                            href="javascript:void(0)"
                            className="btn btn-outline-primary btn-sm"
                          >
                            Buy Now
                          </a>
                        </li>
                      </ul>
                    </div> */}
                  </div>
                </div>
              </footer>
            </div>
          </div>
        </div>
  )
}

export default Audiometer
